export default "__VITE_ASSET__b2d5ed37__"